webpackJsonp([7,55,56,71,72,73,74,75,176,177,253,254],{

/***/ 1250:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tags: ['Auckland', 'Wellington', 'Very long string that would overflow']
        };
    }
});

/***/ }),

/***/ 1251:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Add some tags"
    }
  }, [_c('b-taginput', {
    attrs: {
      "ellipsis": "",
      "icon": "label",
      "placeholder": "Add a tag"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Tags:")]), _vm._v(" " + _vm._s(_vm.tags))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1252:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _data = __webpack_require__(902);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            filteredTags: _data,
            isSelectOnly: false,
            tags: [],
            allowNew: false,
            openOnFocus: false
        };
    },

    methods: {
        getFilteredTags: function getFilteredTags(text) {
            this.filteredTags = _data.filter(function (option) {
                return option.user.first_name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0;
            });
        }
    }
});

/***/ }),

/***/ 1253:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('b-switch', {
    model: {
      value: (_vm.allowNew),
      callback: function($$v) {
        _vm.allowNew = $$v
      },
      expression: "allowNew"
    }
  }, [_vm._v("\n                Allow new tags\n            ")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.openOnFocus),
      callback: function($$v) {
        _vm.openOnFocus = $$v
      },
      expression: "openOnFocus"
    }
  }, [_vm._v("\n                Open on focus\n            ")])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Enter some tags"
    }
  }, [_c('b-taginput', {
    attrs: {
      "data": _vm.filteredTags,
      "autocomplete": "",
      "allow-new": _vm.allowNew,
      "open-on-focus": _vm.openOnFocus,
      "field": "user.first_name",
      "icon": "label",
      "placeholder": "Add a tag"
    },
    on: {
      "typing": _vm.getFilteredTags
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('pre', {
    staticStyle: {
      "max-height": "400px"
    }
  }, [_c('b', [_vm._v("Tags:")]), _vm._v(_vm._s(_vm.tags))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1254:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _data = __webpack_require__(902);

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            filteredTags: _data,
            isSelectOnly: false,
            tags: []
        };
    },

    methods: {
        getFilteredTags: function getFilteredTags(text) {
            this.filteredTags = _data.filter(function (option) {
                return option.user.first_name.toString().toLowerCase().indexOf(text.toLowerCase()) >= 0;
            });
        }
    }
});

/***/ }),

/***/ 1255:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Enter some tags"
    }
  }, [_c('b-taginput', {
    attrs: {
      "data": _vm.filteredTags,
      "autocomplete": "",
      "field": "user.first_name",
      "icon": "label",
      "placeholder": "Add a tag"
    },
    on: {
      "typing": _vm.getFilteredTags
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('strong', [_vm._v(_vm._s(props.option.id))]), _vm._v(": " + _vm._s(props.option.user.first_name) + "\n                ")]
      }
    }]),
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("\n                    There are no items\n                ")])], 2)], 1), _vm._v(" "), _c('pre', {
    staticStyle: {
      "max-height": "400px"
    }
  }, [_c('b', [_vm._v("Tags:")]), _vm._v(_vm._s(_vm.tags))])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1256:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Limited to 10 characters"
    }
  }, [_c('b-taginput', {
    attrs: {
      "maxlength": "10",
      "value": ['Bulma', 'Vue', 'Buefy']
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Limited to 5 tags"
    }
  }, [_c('b-taginput', {
    attrs: {
      "maxtags": "5",
      "value": ['One', 'Two', 'Three', 'Four']
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Limited to 10 characters and 5 tags"
    }
  }, [_c('b-taginput', {
    attrs: {
      "maxlength": "10",
      "maxtags": "5",
      "value": ['Red', 'Green', 'Blue', 'White']
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Success",
      "type": "is-success"
    }
  }, [_c('b-taginput', {
    attrs: {
      "value": ['Tag']
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Error",
      "type": "is-danger"
    }
  }, [_c('b-taginput', {
    attrs: {
      "value": ['Tag']
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Info",
      "type": "is-info"
    }
  }, [_c('b-taginput', {
    attrs: {
      "value": ['Tag']
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Warning",
      "type": "is-warning"
    }
  }, [_c('b-taginput', {
    attrs: {
      "value": ['Tag']
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Disabled"
    }
  }, [_c('b-taginput', {
    attrs: {
      "value": ['Tag'],
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Loading"
    }
  }, [_c('b-taginput', {
    attrs: {
      "value": ['Tag'],
      "loading": ""
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tags: ['Auckland', 'Wellington', 'Napier']
        };
    }
});

/***/ }),

/***/ 1259:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Dark"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-dark"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Info"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-info"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Success"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-success"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Warning"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-warning"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Danger"
    }
  }, [_c('b-taginput', {
    attrs: {
      "type": "is-danger"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tags: ['Auckland', 'Wellington', 'Napier']
        };
    }
});

/***/ }),

/***/ 1261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Small"
    }
  }, [_c('b-taginput', {
    attrs: {
      "size": "is-small"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Default"
    }
  }, [_c('b-taginput', {
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Medium"
    }
  }, [_c('b-taginput', {
    attrs: {
      "size": "is-medium"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Large"
    }
  }, [_c('b-taginput', {
    attrs: {
      "size": "is-large"
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tags: ['Auckland', 'Wellington', 'Napier']
        };
    }
});

/***/ }),

/***/ 1263:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Rounded"
    }
  }, [_c('b-taginput', {
    attrs: {
      "rounded": ""
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Attached"
    }
  }, [_c('b-taginput', {
    attrs: {
      "attached": ""
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tags: ['123', '456', '789']
        };
    },

    methods: {
        beforeAdding: function beforeAdding(tag) {
            return tag.length === 3;
        }
    }
});

/***/ }),

/***/ 1265:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Tags with 3 characters"
    }
  }, [_c('b-taginput', {
    attrs: {
      "before-adding": _vm.beforeAdding
    },
    model: {
      value: (_vm.tags),
      callback: function($$v) {
        _vm.tags = $$v
      },
      expression: "tags"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_taginput__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables_taginput__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExAutocomplete__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__examples_ExAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExAutocomplete__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExTemplatedAutocomplete__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExTemplatedAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__examples_ExTemplatedAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExTemplatedAutocomplete__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExTemplatedAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExTemplatedAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExLimit__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExLimit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__examples_ExLimit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExLimit__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExLimit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExLimit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExState__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__examples_ExState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExState__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExState___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExState__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__examples_ExType__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__examples_ExType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__examples_ExType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExType__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__examples_ExSize__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__examples_ExSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__examples_ExSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExSize__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__examples_ExModifier__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__examples_ExModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__examples_ExModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExModifier__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExModifier___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExModifier__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__examples_ExValidation__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__examples_ExValidation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__examples_ExValidation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExValidation__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExValidation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExValidation__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//































/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_taginput__["default"],
            variables: __WEBPACK_IMPORTED_MODULE_1__variables_taginput__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default.a,
            ExAutocomplete: __WEBPACK_IMPORTED_MODULE_4__examples_ExAutocomplete___default.a,
            ExTemplatedAutocomplete: __WEBPACK_IMPORTED_MODULE_6__examples_ExTemplatedAutocomplete___default.a,
            ExLimit: __WEBPACK_IMPORTED_MODULE_8__examples_ExLimit___default.a,
            ExState: __WEBPACK_IMPORTED_MODULE_10__examples_ExState___default.a,
            ExType: __WEBPACK_IMPORTED_MODULE_12__examples_ExType___default.a,
            ExSize: __WEBPACK_IMPORTED_MODULE_14__examples_ExSize___default.a,
            ExModifier: __WEBPACK_IMPORTED_MODULE_16__examples_ExModifier___default.a,
            ExValidation: __WEBPACK_IMPORTED_MODULE_18__examples_ExValidation___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_3__raw_loader_examples_ExSimple___default.a,
            ExAutocompleteCode: __WEBPACK_IMPORTED_MODULE_5__raw_loader_examples_ExAutocomplete___default.a,
            ExTemplatedAutocompleteCode: __WEBPACK_IMPORTED_MODULE_7__raw_loader_examples_ExTemplatedAutocomplete___default.a,
            ExLimitCode: __WEBPACK_IMPORTED_MODULE_9__raw_loader_examples_ExLimit___default.a,
            ExStateCode: __WEBPACK_IMPORTED_MODULE_11__raw_loader_examples_ExState___default.a,
            ExTypeCode: __WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExType___default.a,
            ExSizeCode: __WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExSize___default.a,
            ExModifierCode: __WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExModifier___default.a,
            ExValidationCode: __WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExValidation___default.a
        };
    }
});

/***/ }),

/***/ 1548:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field label=\"Add some tags\">\n            <b-taginput\n                v-model=\"tags\"\n                ellipsis\n                icon=\"label\"\n                placeholder=\"Add a tag\">\n            </b-taginput>\n        </b-field>\n        <p class=\"content\"><b>Tags:</b> {{ tags }}</p>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                tags: [\n                    'Auckland',\n                    'Wellington',\n                    'Very long string that would overflow'\n                ]\n            }\n        }\n    }\n</script>\n\n"

/***/ }),

/***/ 1549:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div class=\"block\">\n            <b-switch v-model=\"allowNew\">\n                Allow new tags\n            </b-switch>\n            <b-switch v-model=\"openOnFocus\">\n                Open on focus\n            </b-switch>\n        </div>\n        <b-field label=\"Enter some tags\">\n            <b-taginput\n                v-model=\"tags\"\n                :data=\"filteredTags\"\n                autocomplete\n                :allow-new=\"allowNew\"\n                :open-on-focus=\"openOnFocus\"\n                field=\"user.first_name\"\n                icon=\"label\"\n                placeholder=\"Add a tag\"\n                @typing=\"getFilteredTags\">\n            </b-taginput>\n        </b-field>\n        <pre style=\"max-height: 400px\"><b>Tags:</b>{{ tags }}</pre>\n    </section>\n</template>\n\n<script>\n    const data = require('@/data/sample.json')\n\n    export default {\n        data() {\n            return {\n                filteredTags: data,\n                isSelectOnly: false,\n                tags: [],\n                allowNew: false,\n                openOnFocus: false\n            }\n        },\n        methods: {\n            getFilteredTags(text) {\n                this.filteredTags = data.filter((option) => {\n                    return option.user.first_name\n                        .toString()\n                        .toLowerCase()\n                        .indexOf(text.toLowerCase()) >= 0\n                })\n            }\n        }\n    }\n</script>\n\n"

/***/ }),

/***/ 1550:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field label=\"Enter some tags\">\n            <b-taginput\n                v-model=\"tags\"\n                :data=\"filteredTags\"\n                autocomplete\n                field=\"user.first_name\"\n                icon=\"label\"\n                placeholder=\"Add a tag\"\n                @typing=\"getFilteredTags\">\n                <template slot-scope=\"props\">\n                    <strong>{{props.option.id}}</strong>: {{props.option.user.first_name}}\n                </template>\n                <template slot=\"empty\">\n                    There are no items\n                </template>\n            </b-taginput>\n        </b-field>\n        <pre style=\"max-height: 400px\"><b>Tags:</b>{{ tags }}</pre>\n    </section>\n</template>\n\n<script>\n    const data = require('@/data/sample.json')\n\n    export default {\n        data() {\n            return {\n                filteredTags: data,\n                isSelectOnly: false,\n                tags: []\n            }\n        },\n        methods: {\n            getFilteredTags(text) {\n                this.filteredTags = data.filter((option) => {\n                    return option.user.first_name\n                        .toString()\n                        .toLowerCase()\n                        .indexOf(text.toLowerCase()) >= 0\n                })\n            }\n        }\n    }\n</script>\n\n"

/***/ }),

/***/ 1551:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field label=\"Limited to 10 characters\">\n            <b-taginput\n                maxlength=\"10\"\n                :value=\"['Bulma', 'Vue', 'Buefy']\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Limited to 5 tags\">\n            <b-taginput\n                maxtags=\"5\"\n                :value=\"['One', 'Two', 'Three', 'Four']\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Limited to 10 characters and 5 tags\">\n            <b-taginput\n                maxlength=\"10\"\n                maxtags=\"5\"\n                :value=\"['Red', 'Green', 'Blue', 'White']\">\n            </b-taginput>\n        </b-field>\n    </section>\n</template>\n"

/***/ }),

/***/ 1552:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field\n            label=\"Success\"\n            type=\"is-success\">\n            <b-taginput\n                :value=\"['Tag']\">\n            </b-taginput>\n        </b-field>\n\n        <b-field\n            label=\"Error\"\n            type=\"is-danger\">\n            <b-taginput\n                :value=\"['Tag']\">\n            </b-taginput>\n        </b-field>\n\n        <b-field\n            label=\"Info\"\n            type=\"is-info\">\n            <b-taginput\n                :value=\"['Tag']\">\n            </b-taginput>\n        </b-field>\n\n        <b-field\n            label=\"Warning\"\n            type=\"is-warning\">\n            <b-taginput\n                :value=\"['Tag']\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Disabled\">\n            <b-taginput\n                :value=\"['Tag']\"\n                disabled>\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Loading\">\n            <b-taginput\n                :value=\"['Tag']\"\n                loading>\n            </b-taginput>\n        </b-field>\n    </section>\n</template>\n"

/***/ }),

/***/ 1553:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field label=\"Dark\">\n            <b-taginput\n                v-model=\"tags\"\n                type=\"is-dark\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Info\">\n            <b-taginput\n                v-model=\"tags\"\n                type=\"is-info\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Success\">\n            <b-taginput\n                v-model=\"tags\"\n                type=\"is-success\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Warning\">\n            <b-taginput\n                v-model=\"tags\"\n                type=\"is-warning\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Danger\">\n            <b-taginput\n                v-model=\"tags\"\n                type=\"is-danger\">\n            </b-taginput>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                tags: [\n                    'Auckland',\n                    'Wellington',\n                    'Napier'\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1554:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field label=\"Small\">\n            <b-taginput\n                v-model=\"tags\"\n                size=\"is-small\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Default\">\n            <b-taginput\n                v-model=\"tags\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Medium\">\n            <b-taginput\n                v-model=\"tags\"\n                size=\"is-medium\">\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Large\">\n            <b-taginput\n                v-model=\"tags\"\n                size=\"is-large\">\n            </b-taginput>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                tags: [\n                    'Auckland',\n                    'Wellington',\n                    'Napier'\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1555:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field label=\"Rounded\">\n            <b-taginput\n                v-model=\"tags\"\n                rounded>\n            </b-taginput>\n        </b-field>\n\n        <b-field label=\"Attached\">\n            <b-taginput\n                v-model=\"tags\"\n                attached>\n            </b-taginput>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                tags: [\n                    'Auckland',\n                    'Wellington',\n                    'Napier'\n                ]\n            }\n        }\n    }\n</script>\n"

/***/ }),

/***/ 1556:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <b-field label=\"Tags with 3 characters\">\n            <b-taginput\n                v-model=\"tags\" \n                :before-adding=\"beforeAdding\">\n            </b-taginput>\n        </b-field>\n    </section>\n</template>\n\n<script>\n    export default {\n        data() {\n            return {\n                tags: [\n                    '123',\n                    '456',\n                    '789'\n                ]\n            }\n        },\n        methods: {\n        \tbeforeAdding(tag) {\n        \t\treturn tag.length === 3;\n        \t},\n        },\n    }\n</script>\n"

/***/ }),

/***/ 1557:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExAutocomplete,
      "code": _vm.ExAutocompleteCode,
      "title": "Autocomplete",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("\n                To have autocomplete functionality, add the "), _c('code', [_vm._v("autocomplete")]), _vm._v(" prop.\n                You can add any prop from "), _c('router-link', {
    attrs: {
      "to": "/documentation/autocomplete"
    }
  }, [_vm._v("Autocomplete")]), _vm._v(" API.\n            ")], 1)]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExTemplatedAutocomplete,
      "code": _vm.ExTemplatedAutocompleteCode,
      "title": "Templated Autocomplete",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("\n                Slots are available for autocomplete items and the empty message, like with the "), _c('router-link', {
    attrs: {
      "to": "/documentation/autocomplete"
    }
  }, [_vm._v("Autocomplete")]), _vm._v(" control.\n            ")], 1)]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExLimit,
      "code": _vm.ExLimitCode,
      "title": "Limits",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("\n                You can limit the length and number of tags with the "), _c('code', [_vm._v("maxlength")]), _vm._v(" and "), _c('code', [_vm._v("maxtags")]), _vm._v(" props.\n                Maxlength counter is only shown when typing.\n            ")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExState,
      "code": _vm.ExStateCode,
      "title": "States",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("You can change the input type setting a "), _c('code', [_vm._v("type")]), _vm._v(" on "), _c('b', [_vm._v("Field")]), _vm._v(".")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExType,
      "code": _vm.ExTypeCode,
      "title": "Tag types",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSize,
      "code": _vm.ExSizeCode,
      "title": "Sizes",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExModifier,
      "code": _vm.ExModifierCode,
      "title": "Modifiers",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("You can change the style of the tags by setting the "), _c('code', [_vm._v("rounded")]), _vm._v(" and "), _c('code', [_vm._v("attached")]), _vm._v(" props.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExValidation,
      "code": _vm.ExValidationCode,
      "title": "Validation",
      "vertical": ""
    }
  }, [_c('p', [_vm._v("You can validate the value before adding it to the tag list")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    props: [{
        name: '<code>v-model</code>',
        description: 'Binding value',
        type: 'Array<String>, Array<Number>, Array<Object>',
        values: '—',
        default: '—'
    }, {
        name: '<code>maxlength</code>',
        description: 'Limits the length of each tag, plus character counter',
        type: 'String, Number',
        values: '—',
        default: '—'
    }, {
        name: '<code>maxtags</code>',
        description: 'Limits the number of tags, plus tag counter',
        type: 'String, Number',
        values: '—',
        default: '—'
    }, {
        name: '<code>has-counter</code>',
        description: 'Show counter when <code>maxlength</code> or <code>maxtags</code> props are passed',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>type</code>',
        description: 'Type (color) of the tags, optional',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '<code>is-light</code>'
    }, {
        name: '<code>size</code>',
        description: 'Tag and input size, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '<code>is-medium</code>'
    }, {
        name: '<code>rounded</code>',
        description: 'Makes the tags rounded, optional',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>attached</code>',
        description: 'Makes the tags attached instead of having an appended delete button, optional',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>ellipsis</code>',
        description: 'Adds ellipsis on tags to not overflow the text. Title is then added to the tag with full text',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>closable</code>',
        description: 'Add close/delete button to the tag',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>field</code>',
        description: 'Property of the object (if <code>data</code> is array of objects) to use as display text',
        type: 'String',
        values: '—',
        default: '<code>value</code>'
    }, {
        name: '<code>autocomplete</code>',
        description: 'Add autocomplete feature (if <code>true</code>, any Autocomplete props may be used too)',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>allow-new</code>',
        description: 'When <code>autocomplete</code>, it allow to add new tags',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>remove-on-keys</code>',
        description: 'Allow removing last tag when pressing given keys, if input is empty',
        type: 'Array',
        values: '—',
        default: '<code>[8]</code>'
    }, {
        name: '<code>confirm-key-codes</code>',
        description: 'Array of key codes which will add a tag when typing (default comma, enter and tab)',
        type: 'Array',
        values: '—',
        default: '<code>[13, 188, 9]</code>'
    }, {
        name: '<code>on-paste-separators</code>',
        description: 'Array of chars used to split when pasting a new string',
        type: 'Array',
        values: '—',
        default: '<code>[\',\']</code>'
    }, {
        name: '<code>before-adding</code>',
        description: 'Function to validate the value of the tag before adding',
        type: 'Function',
        values: '—',
        default: '<code>(tagToAdd) => true</code>'
    }, {
        name: '<code>allow-duplicates</code>',
        description: 'Allows adding the same tag multiple times',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>readonly</code>',
        description: 'Disable input/typing',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>check-infinite-scroll</code>',
        description: 'Makes the autocomplete component check if list reached scroll end and emit <code>infinite-sroll</code> event.',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: 'Any other native attribute',
        description: '—',
        type: '—',
        values: '—',
        default: '—'
    }],
    slots: [{
        name: 'default',
        description: '',
        props: '<code>option: String|Object</code>, <code>index: Number</code>'
    }, {
        name: '<code>empty</code>',
        description: 'Show like an option if <code>data</code> array prop is empty',
        props: '—'
    }, {
        name: '<code>header</code>',
        description: 'Show a custom header as first option',
        props: '—'
    }],
    events: [{
        name: '<code>input</code>',
        description: 'Triggers when tags are added/removed',
        parameters: '<code>value: Array</code>'
    }, {
        name: '<code>typing</code>',
        description: 'User started typing a tag',
        parameters: '<code>value: String</code>'
    }, {
        name: '<code>add</code>',
        description: 'Triggers when a tag has been added',
        parameters: '<code>value: String|Object</code>'
    }, {
        name: '<code>remove</code>',
        description: 'Triggers when a tag has been removed',
        parameters: '<code>value: String|Object</code>'
    }, {
        name: '<code>infinite-scroll</code>',
        description: 'Triggers when the autocomplete <code>.dropdown-list</code> has reached scroll end',
        parameters: '—'
    }]
}]);

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    name: '<code>$taginput-height</code>',
    default: '<code>1.7em</code>'
}]);

/***/ }),

/***/ 319:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1250),
  /* template */
  __webpack_require__(1251),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1252),
  /* template */
  __webpack_require__(1253),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1254),
  /* template */
  __webpack_require__(1255),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 322:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1256),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(1257),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1258),
  /* template */
  __webpack_require__(1259),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1260),
  /* template */
  __webpack_require__(1261),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1262),
  /* template */
  __webpack_require__(1263),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1264),
  /* template */
  __webpack_require__(1265),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1547),
  /* template */
  __webpack_require__(1557),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 902:
/***/ (function(module, exports) {

module.exports = [{"id":1,"user":{"first_name":"Jesse","last_name":"Simmons"},"date":"2016/10/15 13:43:27","gender":"Male"},{"id":2,"user":{"first_name":"John","last_name":"Jacobs"},"date":"2016/12/15 06:00:53","gender":"Male"},{"id":3,"user":{"first_name":"Tina","last_name":"Gilbert"},"date":"2016/04/26 06:26:28","gender":"Female"},{"id":4,"user":{"first_name":"Clarence","last_name":"Flores"},"date":"2016/04/10 10:28:46","gender":"Male"},{"id":5,"user":{"first_name":"Anne","last_name":"Lee"},"date":"2016/12/06 14:38:38","gender":"Female"},{"id":6,"user":{"first_name":"Sara","last_name":"Armstrong"},"date":"2016/09/23 18:50:04","gender":"Female"},{"id":7,"user":{"first_name":"Anthony","last_name":"Webb"},"date":"2016/08/30 23:49:38","gender":"Male"},{"id":8,"user":{"first_name":"Andrew","last_name":"Greene"},"date":"2016/11/20 14:57:47","gender":"Male"},{"id":9,"user":{"first_name":"Russell","last_name":"White"},"date":"2016/07/13 09:29:49","gender":"Male"},{"id":10,"user":{"first_name":"Lori","last_name":"Hunter"},"date":"2016/12/09 01:44:05","gender":"Female"},{"id":11,"user":{"first_name":"Ronald","last_name":"Wood"},"date":"2016/12/04 02:23:48","gender":"Male"},{"id":12,"user":{"first_name":"Michael","last_name":"Harper"},"date":"2016/07/27 13:28:15","gender":"Male"},{"id":13,"user":{"first_name":"George","last_name":"Dunn"},"date":"2017/03/07 12:26:52","gender":"Male"},{"id":14,"user":{"first_name":"Eric","last_name":"Rogers"},"date":"2016/06/07 05:41:52","gender":"Male"},{"id":15,"user":{"first_name":"Juan","last_name":"Meyer"},"date":"2017/02/01 04:56:34","gender":"Male"},{"id":16,"user":{"first_name":"Lori","last_name":"Shaw"},"date":"2017/01/26 11:50:04","gender":"Female"},{"id":17,"user":{"first_name":"Lori","last_name":"Cunningham"},"date":"2016/05/01 10:00:56","gender":"Female"},{"id":18,"user":{"first_name":"Charles","last_name":"Graham"},"date":"2016/05/31 06:43:30","gender":"Male"},{"id":19,"user":{"first_name":"Henry","last_name":"Morrison"},"date":"2016/09/27 16:15:44","gender":"Male"},{"id":20,"user":{"first_name":"Albert","last_name":"Mendoza"},"date":"2016/08/08 05:29:24","gender":"Male"},{"id":21,"user":{"first_name":"Ruby","last_name":"Snyder"},"date":"2017/04/01 12:04:39","gender":"Female"},{"id":22,"user":{"first_name":"Jesse","last_name":"Warren"},"date":"2016/08/20 01:36:38","gender":"Male"},{"id":23,"user":{"first_name":"Carlos","last_name":"Ferguson"},"date":"2016/05/31 10:40:29","gender":"Male"},{"id":24,"user":{"first_name":"Melissa","last_name":"Peters"},"date":"2016/07/23 00:41:54","gender":"Female"},{"id":25,"user":{"first_name":"Arthur","last_name":"Garza"},"date":"2017/03/11 14:11:37","gender":"Male"},{"id":26,"user":{"first_name":"Joe","last_name":"Berry"},"date":"2016/07/09 15:16:56","gender":"Male"},{"id":27,"user":{"first_name":"Joseph","last_name":"Bishop"},"date":"2016/10/04 19:44:54","gender":"Male"},{"id":28,"user":{"first_name":"Sarah","last_name":"Harper"},"date":"2016/09/23 05:09:11","gender":"Female"},{"id":29,"user":{"first_name":"Christopher","last_name":"Fuller"},"date":"2016/04/12 00:05:35","gender":"Male"},{"id":30,"user":{"first_name":"Alan","last_name":"Mendoza"},"date":"2016/04/22 10:48:02","gender":"Male"},{"id":31,"user":{"first_name":"James","last_name":"Davis"},"date":"2017/01/16 15:17:03","gender":"Male"},{"id":32,"user":{"first_name":"Scott","last_name":"Welch"},"date":"2016/10/04 23:31:51","gender":"Male"},{"id":33,"user":{"first_name":"Mildred","last_name":"Myers"},"date":"2016/11/23 13:46:18","gender":"Female"},{"id":34,"user":{"first_name":"Victor","last_name":"Martinez"},"date":"2016/04/06 17:05:07","gender":"Male"},{"id":35,"user":{"first_name":"Susan","last_name":"Medina"},"date":"2016/12/09 10:33:37","gender":"Female"},{"id":36,"user":{"first_name":"Judy","last_name":"Long"},"date":"2016/07/26 16:19:04","gender":"Female"},{"id":37,"user":{"first_name":"Joan","last_name":"Myers"},"date":"2016/09/22 04:55:54","gender":"Female"},{"id":38,"user":{"first_name":"Rachel","last_name":"Gonzales"},"date":"2016/07/15 13:56:38","gender":"Female"},{"id":39,"user":{"first_name":"Roger","last_name":"Hunt"},"date":"2016/08/14 10:43:11","gender":"Male"},{"id":40,"user":{"first_name":"Dorothy","last_name":"Howard"},"date":"2016/06/19 05:34:49","gender":"Female"},{"id":41,"user":{"first_name":"Eugene","last_name":"Lynch"},"date":"2016/12/24 08:19:24","gender":"Male"},{"id":42,"user":{"first_name":"Kathy","last_name":"Webb"},"date":"2017/04/01 21:09:05","gender":"Female"},{"id":43,"user":{"first_name":"Antonio","last_name":"White"},"date":"2017/02/10 06:51:20","gender":"Male"},{"id":44,"user":{"first_name":"Louis","last_name":"Spencer"},"date":"2016/10/08 02:20:22","gender":"Male"},{"id":45,"user":{"first_name":"Andrea","last_name":"Marshall"},"date":"2016/09/04 10:59:57","gender":"Female"},{"id":46,"user":{"first_name":"Eugene","last_name":"Sims"},"date":"2017/03/15 06:39:48","gender":"Male"},{"id":47,"user":{"first_name":"Mildred","last_name":"Gibson"},"date":"2016/04/18 06:43:54","gender":"Female"},{"id":48,"user":{"first_name":"Joan","last_name":"Arnold"},"date":"2016/12/16 04:52:23","gender":"Female"},{"id":49,"user":{"first_name":"Jesse","last_name":"Schmidt"},"date":"2016/06/11 02:44:33","gender":"Male"},{"id":50,"user":{"first_name":"David","last_name":"Frazier"},"date":"2017/02/15 21:46:30","gender":"Male"},{"id":51,"user":{"first_name":"Nicholas","last_name":"Howell"},"date":"2016/11/01 15:08:31","gender":"Male"},{"id":52,"user":{"first_name":"Douglas","last_name":"Chapman"},"date":"2017/02/08 03:33:24","gender":"Male"},{"id":53,"user":{"first_name":"Bruce","last_name":"Simmons"},"date":"2016/07/14 12:11:17","gender":"Male"},{"id":54,"user":{"first_name":"Antonio","last_name":"George"},"date":"2016/11/07 19:12:55","gender":"Male"},{"id":55,"user":{"first_name":"Chris","last_name":"Marshall"},"date":"2016/07/03 12:11:45","gender":"Male"},{"id":56,"user":{"first_name":"Ashley","last_name":"Hudson"},"date":"2016/10/14 21:08:05","gender":"Female"},{"id":57,"user":{"first_name":"Alan","last_name":"Edwards"},"date":"2017/03/22 21:10:25","gender":"Male"},{"id":58,"user":{"first_name":"George","last_name":"Clark"},"date":"2016/04/28 03:15:05","gender":"Male"},{"id":59,"user":{"first_name":"Frank","last_name":"Porter"},"date":"2016/09/08 00:48:14","gender":"Male"},{"id":60,"user":{"first_name":"Christopher","last_name":"Palmer"},"date":"2016/05/24 08:58:12","gender":"Male"}]

/***/ })

});


// WEBPACK FOOTER //
// static/js/7.cef42ba1dc3de1def269.js